import { put, takeLatest } from "redux-saga/effects";
import {
  GET_PROFILE_DETAILS,
  GET_PROFILE_DETAILS_FAILED,
  GET_PROFILE_DETAILS_INIT,
  GET_PROFILE_DETAILS_SUCCESS,
  GET_ALLOCATOR_Strategy,
  GET_ALLOCATOR_Strategy_INIT,
  GET_ALLOCATOR_Strategy_SUCCESS,
  GET_ALLOCATOR_Strategy_FAILED,
  GET_STRATEGY,
  GET_STRATEGY_SUCCESS,
  GET_STRATEGY_INIT,
  GET_STRATEGY_FAILED,
  GET_ALL_INVESTOR,
  GET_ALL_INVESTOR_INIT,
  GET_ALL_INVESTOR_SUCCESS,
  GET_ALL_INVESTOR_FAILED,
  GET_COMPANY_POST_FEED_INIT,
  GET_COMPANY_POST_FEED_SUCCESS,
  GET_COMPANY_POST_FEED_FAILED,
  GET_COMPANY_POST_FEED,
  GET_COMPANY_USERS_INIT,
  GET_COMPANY_USERS_SUCCESS,
  GET_COMPANY_USERS_FAILED,
  GET_COMPANY_USERS,
  CREATE_ALLOCATOR_NETWORKS_INIT,
  CREATE_ALLOCATOR_NETWORKS_SUCCESS,
  CREATE_ALLOCATOR_NETWORKS_FAILED,
  UPDATE_ALLOCATOR_NETWORKS_INIT,
  UPDATE_ALLOCATOR_NETWORKS_SUCCESS,
  UPDATE_ALLOCATOR_NETWORKS_FAILED,
  DELETE_ALLOCATOR_NETWORKS_INIT,
  DELETE_ALLOCATOR_NETWORKS_SUCCESS,
  DELETE_ALLOCATOR_NETWORKS_FAILED,
  CREATE_ALLOCATOR_NETWORKS,
  UPDATE_ALLOCATOR_NETWORKS,
  DELETE_ALLOCATOR_NETWORKS
} from "./constants";
import { deleteUtil, getUtil, postUtil } from "../../services/axiosClient";
import { API } from "../../utils/Constant";
import GenerateUrl from "@hedgefund/shared/src/GenerateUrl";

const getPostFeed = [
  { keyword : "tenantId", value : "tenantId"},
  { keyword: "page", value: "page" },
  { keyword: "perPage", value: "perPage" },
]

function* getProfileDetail({ payload }) {
  yield put({ type: GET_PROFILE_DETAILS_INIT });
  try {
    const res = yield getUtil(`${API.GetAllocatorProfileDetail}?id=${payload}`);
    if (res?.status === 200) {
      const { data } = res;

      yield put({ type: GET_PROFILE_DETAILS_SUCCESS, payload: data.result });
    } else {
      yield put({ type: GET_PROFILE_DETAILS_FAILED });
    }
  } catch (error) {
    yield put({ type: GET_PROFILE_DETAILS_FAILED });
    throw new Error(error);
  }
}

function* getAllocatorStrategySaga() {
  yield put({ type: GET_ALLOCATOR_Strategy_INIT });
  try {
    const res = yield getUtil(API.AllocatorStrategy);
    if (res?.status === 200) {
      const { data } = res;

      yield put({ type: GET_ALLOCATOR_Strategy_SUCCESS, payload: data.result });
    } else {
      yield put({ type: GET_ALLOCATOR_Strategy_FAILED });
    }
  } catch (error) {
    yield put({ type: GET_ALLOCATOR_Strategy_FAILED });
    throw new Error(error);
  }
}

function* strategySaga() {
  yield put({ type: GET_STRATEGY_INIT });
  try {
    const res = yield getUtil(API.Strategy);
    if (res?.status === 200) {
      const { data } = res;

      yield put({ type: GET_STRATEGY_SUCCESS, payload: data.result });
    } else {
      yield put({ type: GET_STRATEGY_FAILED });
    }
  } catch (error) {
    yield put({ type: GET_STRATEGY_FAILED });
    throw new Error(error);
  }
}

function* getallInvestorsSaga() {
  yield put({ type: GET_ALL_INVESTOR_INIT });
  try {
    const res = yield getUtil(API.InvestorType);
    if (res?.status === 200) {
      const { data } = res;
      yield put({ type: GET_ALL_INVESTOR_SUCCESS, payload: data.result });
    } else {
      yield put({ type: GET_ALL_INVESTOR_FAILED });
    }
  } catch (error) {
    yield put({ type: GET_ALL_INVESTOR_FAILED });
    throw new Error(error);
  }
}

function* getCurrentCompanyPostFeedSaga({ payload }) {
  yield put({ type: GET_COMPANY_POST_FEED_INIT });
  try {
    const url = API.GetCompanyPostFeed + GenerateUrl(payload, getPostFeed);

    const res = yield getUtil(url);
    if (res?.status === 200) {
      const { data } = res;
      yield put({ type: GET_COMPANY_POST_FEED_SUCCESS, payload: data.result });
    } else {
      yield put({ type: GET_COMPANY_POST_FEED_FAILED });
    }
  } catch (error) {
    yield put({ type: GET_COMPANY_POST_FEED_FAILED });
    throw new Error(error);
  }
}

function* getCurrentCompanyUsersSaga({ payload}) {
  yield put({ type: GET_COMPANY_USERS_INIT });
  try {
    const res = yield getUtil(`${API.GetCompanyUsers}?id=${payload}`);
    if (res?.status === 200) {
      const { data } = res;
      yield put({ type: GET_COMPANY_USERS_SUCCESS, payload: data.result });
    } else {
      yield put({ type: GET_COMPANY_USERS_FAILED });
    }
  } catch (error) {
    yield put({ type: GET_COMPANY_USERS_FAILED });
    throw new Error(error);
  }
}

export function* createAllocatorNetwork({ payload }) {
  try {
      yield put({ type: CREATE_ALLOCATOR_NETWORKS_INIT });

      const res = yield postUtil(API.CreateConnection, payload);
      if (res?.status === 200) {
          const { data } = res;

          yield put({
              type: CREATE_ALLOCATOR_NETWORKS_SUCCESS,
              payload: data.result,
          });
      } else {
          yield put({ type: CREATE_ALLOCATOR_NETWORKS_FAILED });
      }
  } catch (error) {
      throw new Error(error);
  }
}


export function* updateAllocatorNetwork({ payload }) {
  try {
      yield put({ type: UPDATE_ALLOCATOR_NETWORKS_INIT });

      const res = yield postUtil(API.UpdateConnection, payload);
      if (res?.status === 200) {
          const { data } = res;

          yield put({
              type: UPDATE_ALLOCATOR_NETWORKS_SUCCESS,
              payload: data.result,
          });
      } else {
          yield put({ type: UPDATE_ALLOCATOR_NETWORKS_FAILED });
      }
  } catch (error) {
      throw new Error(error);
  }
}

export function* deleteAllocatorNetwork({ payload }) {
  try {
      yield put({ type: DELETE_ALLOCATOR_NETWORKS_INIT });

      const res = yield deleteUtil(`${API.DeleteConnection}?id=${payload}`);
      if (res?.status === 200) {
          const { data } = res;

          yield put({
              type: DELETE_ALLOCATOR_NETWORKS_SUCCESS,
              payload: data.result,
          });
      } else {
          yield put({ type: DELETE_ALLOCATOR_NETWORKS_FAILED });
      }
  } catch (error) {
      throw new Error(error);
  }
}


export function* allocatorProfile() {
  yield takeLatest(GET_PROFILE_DETAILS, getProfileDetail);
  yield takeLatest(GET_ALLOCATOR_Strategy, getAllocatorStrategySaga);
  yield takeLatest(GET_STRATEGY, strategySaga);
  yield takeLatest(GET_ALL_INVESTOR, getallInvestorsSaga);
  yield takeLatest(GET_COMPANY_POST_FEED, getCurrentCompanyPostFeedSaga);
  yield takeLatest(GET_COMPANY_USERS, getCurrentCompanyUsersSaga);
  yield takeLatest(CREATE_ALLOCATOR_NETWORKS, createAllocatorNetwork);
  yield takeLatest(UPDATE_ALLOCATOR_NETWORKS, updateAllocatorNetwork);
  yield takeLatest(DELETE_ALLOCATOR_NETWORKS, deleteAllocatorNetwork);
}
